import { useContext, useEffect, useState } from 'react';
import invariant from 'ts-invariant';
import { getWaysteContext } from '../context/WaysteContext';
/**
 * Provides the teams for the current user's organization, fetched once and cached on the client
 * (the organization is derived from the current profile's admin-portal authority). Reactive — it
 * re-renders when the cached teams load.
 *
 * @param override - Optional WaysteClient instance to override the client from the context.
 * @returns `{ teams, teamLabel }` where `teamLabel(code)` returns the team's display label, falling
 *   back to the raw code if the teams haven't loaded yet or the code is unknown.
 */
export function useTeams(override) {
    const context = useContext(getWaysteContext());
    const client = override || context.client;
    invariant(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <WaysteProvider>, or pass an WaysteClient ' +
        'instance in via options.');
    const [teams, setTeams] = useState(client.profile().teams);
    useEffect(() => {
        const sub = client.profile().teamsObservable.subscribe((nextTeams) => setTeams(nextTeams));
        return () => sub.unsubscribe();
    }, [client]);
    const teamLabel = (code) => teams.find((team) => team.code === code)?.label ?? code;
    return { teams, teamLabel };
}
//# sourceMappingURL=useTeams.js.map